export default {
    legacy: false,
    locale: 'pl',
    fallbackLocale: 'pl',
    pluralRules: {
        pl(choice: number): number {
            if (choice === 1) {
                return 0
            }
            if (choice % 10 >= 2 && choice % 10 <= 4 && (choice % 100 < 10 || choice % 100 >= 20)) {
                return 1
            }
            return 2
        },
    },
}
